// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget-list-item[data-v-1ff718d5]{background:#f6f6f6;color:#545454}.widget-list-item[data-v-1ff718d5]:hover{color:#2b2b2b}", ""]);
// Exports
module.exports = exports;
